import { createSlice } from '@reduxjs/toolkit';

export const SEVEARITY_CONTS = {
    error: "error",
    warning: "warning",
    info: "info",
    success: "success"
}

const initialState = {
    show: false,
    message: "",
    severity: ""
};

const nudgeSlice = createSlice({
    name: 'Nudge',
    initialState,
    reducers: {
        showNudge: (state, action) => {
            state.show = true;
            state.message = action.payload.message
            state.severity = action.payload.type
        },
        hideNudge: (state) => {
            state.show = false;
            state.message = "";
            state.severity = ""
        },
    },
});

export const {
    showNudge,
    hideNudge
} = nudgeSlice.actions;

export default nudgeSlice.reducer;
